import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompletedComponent } from './completed.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [CompletedComponent],
  imports: [CommonModule, TranslateModule],
  exports: [CompletedComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class CompletedModule {}
